/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

export const Pagination = {
    name: 'Pagination',
    props:{
        total: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
    },
    template: `
        <div class="articles__wrap-grid-pagination">
            <a 
            class="articles__wrap-grid-pagination-pag"
            @click="$emit('minusPage')"
            >‹</a>
            <a 
                v-for="page in total" 
                :key="page" 
                class="articles__wrap-grid-pagination-pag" 
                :class="{
                'active': currentPage == page
                }"
                @click="$emit('changePage', page)"
            >{{ page }}</a>
       
            <a 
            class="articles__wrap-grid-pagination-pag"
            @click="$emit('plusPage')"
            >›</a>
        </div>
    `
}